module.exports = __webpack_public_path__ + "static/media/STPLong2w522@2x.04d58148.jpg";